import { render } from "./IMUserDetail.vue?vue&type=template&id=53285702&scoped=true&ts=true"
import script from "./IMUserDetail.vue?vue&type=script&lang=ts"
export * from "./IMUserDetail.vue?vue&type=script&lang=ts"

import "./IMUserDetail.vue?vue&type=style&index=0&id=53285702&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53285702"],['__file',"src/views/applications/IMUserDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53285702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53285702', __exports__)) {
    console.log('reload')
    api.reload('53285702', __exports__)
  }
  
  module.hot.accept("./IMUserDetail.vue?vue&type=template&id=53285702&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('53285702', render)
  })

}


export default __exports__